export const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";
export const PHONE_TEL = process.env.REACT_APP_PHONE_NUMBER || "";
export const PHONE_DISPLAY = process.env.REACT_APP_PHONE_DISPLAY || "";
export const ADDRESS = process.env.REACT_APP_ACADEMY_ADDRESS || "LaunchX Academy";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PRIVACY_POLICY_VERSION = "2026-09-26";
export const TERMS_VERSION = "2026-09-26";

export const DEFAULT_WA_MSG =
  "Hi LaunchX Academy, I want to know more about the 45-Day Practical Online Business Program. Please share admission details.";

export const waLink = (msg = DEFAULT_WA_MSG) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const ATTR_KEY = "lx_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export const captureAttribution = () => {
  try {
    if (sessionStorage.getItem(ATTR_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const attr = { referrer: document.referrer || "", first_page: window.location.href };
    UTM_KEYS.forEach((k) => {
      attr[k] = params.get(k) || "";
    });
    sessionStorage.setItem(ATTR_KEY, JSON.stringify(attr));
  } catch {
    /* storage unavailable */
  }
};

export const getAttribution = () => {
  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(ATTR_KEY) || "{}");
  } catch {
    stored = {};
  }
  return {
    utm_source: stored.utm_source || null,
    utm_medium: stored.utm_medium || null,
    utm_campaign: stored.utm_campaign || null,
    utm_content: stored.utm_content || null,
    utm_term: stored.utm_term || null,
    first_page: stored.first_page || window.location.href,
    landing_page: stored.first_page || window.location.href,
    referrer: stored.referrer || null,
    current_page: window.location.href,
  };
};
